export default __webpack_public_path__ + "static/media/Helvetica-Bold.093afcda.woff";